const translations = {
  en: {
    interestForm: "CLOSED",
    church_interestForm: "CLOSED",
    header: {
      recap: "2025 RECAP",
      participate: "PARTICIPATE",
    },
    about: {
      date: "MARCH 20-22, 2026",
      mission_1: "TO BE A",
      mission_highlight_1: "VISIBLE DISPLAY",
      mission_and: "AND",
      mission_highlight_2: "VIABLE DEMONSTRATION OF",
      mission_2: "GOD'S LOVE FOR THE CITY",
      learnHow: "LEARN HOW YOU CAN TAKE PART",
      whatIs: "WHAT IS CITYSERVE?",
      promo: "ARE YOU READY FOR CITYSERVE 2026?",
      description_1:
        "CityServe Hong Kong is a city-wide movement for local churches united in their mission to serve communities across Hong Kong and to demonstrate God’s love for the city.",
      description_2:
        "CityServe aspires to be a transformative movement that connects churches and local NGOs & charitable organizations each year on a designated weekend. We aim to serve as our expression of worship. Our mission is to be witnesses of God’s love by actively loving and serving the poor, marginalized, and unreached individuals in Hong Kong. Through our collective efforts, we hope to inspire the city to take notice and proclaim the good news through our acts of service, fostering a community rooted in compassion and hope.",
      recap: "CHECK OUT WHAT HAPPENED IN CITYSERVE 2025",
    },
    socialNeed: {
      title: "serving the social needs of HK",
      description:
        "We identified 10 key social needs in Hong Kong to guide our service efforts",
      children: "CHILDREN",
      domesticHelpers: "DOMESTIC HELPERS",
      domesticIssues: "DOMESTIC ISSUES",
      elderly: "ELDERLY",
      ethnicMinorities: "ETHNIC MINORITIES",
      handicapped: "PEOPLE WITH DISABILITIES",
      environmental: "CREATION CARE",
      poor: "POOR & HOMELESS",
      mentalHealth: "MENTAL HEALTH ISSUES",
      lowIncome: "LOW INCOME FAMILIES",
    },
    joinUs: {
      title: "Join us in Cityserve 2026",
      description:
        "If you would like to take part in CityServe 2026 or if you have any questions, sign up in the form below or contact us ",
      button_registration: "CLOSED",
      button_giving: "GIVE TO CITYSERVE",
      link: "admin@cityserve.hk",
    },
    recap: {
      title: "A RECAP OF CITYSERVE 2025",
      description:
        "The 2025 CityServe took place on Sunday, April 4-6th. Churches, organizations, and participants came together to serve the different needs of the city. Below are the stats of impact. Check out the video to learn more about what happened and how we saw God’s love demonstrated throughout the city!",
      participants: "PARTICIPANTS",
      churches: "CHURCHES",
      ngos: "NGOs",
      peopleReached: "PEOPLE REACHED",
    },
    participate: {
      howTo: "How can YOU take part in CityServe this year?",
      avenues:
        "Whether you’re a church, an NGO, or charity, we have various avenues to have you take part in CityServe.",
      forIndividuals: "FOR INDIVIDUALS",
      forChurches: "FOR CHURCHES",
      chooseMode:
        "you may choose from the below 3 CITYSERVE MODEs to join in the movement:",
      participant: "Participant",
      participantDescription:
        "Invite your members or small groups to join in a pre-planned event organized by CityServe Planning Committee. These members will be joined by participants from other churches to serve one of 10 social categories.",
      partner: "partner",
      partnerDescription:
        "CityServe Planning Committee will partner with your church to plan an event for your congregation. Connections and resources will be shared to empower your congregation for a serving experience during CityServe.",
      planner: "Planner",
      plannerDescription:
        "Plan within your church to create your own CityServe event with your network and connections to be a part of the movement.",
      forNGOs: "FOR NGOS / CHARITY",
      ifNGOs: "If you are an ngo or charity, you can:",
      engage: "Engage",
      engageDescription:
        "Engage with the needy by loving the city through different existing initiatives and activities.",
      empower: "Empower",
      empowerDescription:
        "Empower churches and ministries by providing participants a platform to serve the city together.",
      exhibit: "Exhibit",
      exhibitDescription:
        "Exhibit the work your organization is engaged in, educate participants on the needs in the city and respective impact to the society.",
    },
    partners: {
      title: "Our Partners",
      description: "Organizations and ministries that partnered with us during",
    },
  },
  zh: {
    header: {
      recap: "2025 回顧",
      participate: "參與",
    },
    interestForm: "该表格已关闭",
    church_interestForm: "该表格已关闭",
    about: {
      date: "2026年 3月20-22日",
      mission_1: "以",
      mission_highlight_1: "具體的服務",
      mission_and: "和",
      mission_highlight_2: "實際的行動",
      mission_2: `向我們的城市表揚上帝的愛`,
      learnHow: "如何參與",
      whatIs: "什麼是CityServe？",
      promo: "你準備好為CityServe 2026服侍了嗎？",
      description_1:
        "CityServe是服務香港全市的一項活動，希望與當地教會和組織合作，一起以具體的方式表達上帝的愛。",
      description_2:
        "CityServe 的願景是啟動一個轉變城市的運動，旨在每年在指定的週末連接教會和當地慈善組織機構。我們的目標是將服務作為我們崇拜的表達。我們的使命是透過實際行動關愛和服務香港的貧困、邊緣化及未接觸的個體，見證上帝的愛。通過我們的共同努力，我們希望激勵城市注意到我們的服務行動，並傳揚好消息，培養根植於同情和希望的社區。",
      interestForm: "CityServe 2026 意向表格",
      recap: "看看2025年 CityServe 的回顧影片",
    },
    socialNeed: {
      title: "服務香港的社會需求",
      description: "我們識別了10個在香港關鍵的社會需求，以指導我們的服務工作",
      children: "兒童",
      domesticHelpers: "家庭傭工",
      domesticIssues: "家庭問題",
      elderly: "老年人",
      ethnicMinorities: "少數族裔",
      handicapped: "傷健人士",
      environmental: "環境問題",
      poor: "貧困和無家者",
      mentalHealth: "心理健康",
      lowIncome: "低收入家庭",
    },
    joinUs: {
      title: "一同參與CityServe2026",
      description:
        "如果您想參加 CityServe 2026 或有任何疑問，請在下面的表格中報名或聯絡我們.",
      button_registration: "该表格已关闭",
      button_giving: "CityServe 奉獻",
      link: "admin@cityserve.hk",
    },
    recap: {
      title: "回顧2025年CityServe",
      description:
        "2025 年的 CityServe 於4月4-6日星期日舉行。不同教會、慈善組織和參加者共聚一堂，服務城市中不同的需求。以下是我們蒐集的影響力統計。請收看我們的視頻以了解我們所經歷的一切以及參加者如何見證上帝的愛被彰顯在香港居民當中！",
      participants: "參加者",
      churches: "教會",
      ngos: "慈善組織",
      peopleReached: "服務對象",
    },
    participate: {
      howTo: "你能如何參與今年的CityServe?",
      avenues:
        "無論您是教會、非政府組織還是慈善機構，我們都有多種途徑讓您參與CityServe。",
      forIndividuals: "個人",
      forChurches: "教會",
      chooseMode: "可以選擇以下其中一個方式參與CityServe:",
      participant: "參與者",
      participantDescription:
        "邀請您的成員或小組參加由CityServe策劃團隊的預定活動。這些隊伍將由來自不同教會的參與者一起組成，他們為其中一個社會需求的服務對象提供服務。",
      partner: "合作者",
      partnerDescription:
        "CityServe策劃團隊將與您的教會合作，為您的會眾策劃一項活動。我們將共享人脈和資源，讓您的會眾在 CityServe 期間獲得服務體驗。",
      planner: "策劃者",
      plannerDescription:
        "透過您已經具有的人脈和資源來創建您自己的CityServe活動，成為這運動的一部分。",
      forNGOs: "慈善組織和機構",
      ifNGOs: "如果你是慈善機構，你可以：",
      engage: "參與服務",
      engageDescription: "通過已經預設的活動服務有需要的人群，關懷我們的城市。",
      empower: "提供資源",
      empowerDescription: "供應你的平台給教會和小組事工參與你的服務活動項目。",
      exhibit: "提供服務機會",
      exhibitDescription:
        "分享您組織的工作，為參與者提供更多的渠道了解城市中的需求以及您的組織對社會的影響。",
    },
    partners: {
      title: "我們的合作夥伴",
      description: "與我們合作的教會和組織",
    },
  },
};

export default translations;
